/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ASMBrain, ASMBrainInterface } from "../ASMBrain";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "initSupply",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60806040523480156200001157600080fd5b5060405162003179380380620031798339818101604052810190620000379190620001ac565b6040518060400160405280600881526020017f41534d427261696e0000000000000000000000000000000000000000000000008152506040518060400160405280600881526020017f41534d427261696e0000000000000000000000000000000000000000000000008152508160009080519060200190620000bb929190620000e5565b508060019080519060200190620000d4929190620000e5565b50505080600a81905550506200026c565b828054620000f390620001e8565b90600052602060002090601f01602090048101928262000117576000855562000163565b82601f106200013257805160ff191683800117855562000163565b8280016001018555821562000163579182015b828111156200016257825182559160200191906001019062000145565b5b50905062000172919062000176565b5090565b5b808211156200019157600081600090555060010162000177565b5090565b600081519050620001a68162000252565b92915050565b600060208284031215620001c557620001c46200024d565b5b6000620001d58482850162000195565b91505092915050565b6000819050919050565b600060028204905060018216806200020157607f821691505b602082108114156200021857620002176200021e565b5b50919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602260045260246000fd5b600080fd5b6200025d81620001de565b81146200026957600080fd5b50565b612efd806200027c6000396000f3fe608060405234801561001057600080fd5b50600436106101165760003560e01c80634f6ccce7116100a2578063a22cb46511610071578063a22cb465146102f3578063b88d4fde1461030f578063c87b56dd1461032b578063d5abeb011461035b578063e985e9c51461037957610116565b80634f6ccce7146102455780636352211e1461027557806370a08231146102a557806395d89b41146102d557610116565b80631249c58b116100e95780631249c58b146101b557806318160ddd146101bf57806323b872dd146101dd5780632f745c59146101f957806342842e0e1461022957610116565b806301ffc9a71461011b57806306fdde031461014b578063081812fc14610169578063095ea7b314610199575b600080fd5b61013560048036038101906101309190611f5d565b6103a9565b604051610142919061236f565b60405180910390f35b610153610423565b604051610160919061238a565b60405180910390f35b610183600480360381019061017e9190611fb7565b6104b5565b6040516101909190612308565b60405180910390f35b6101b360048036038101906101ae9190611f1d565b61053a565b005b6101bd610652565b005b6101c7610665565b6040516101d491906125ac565b60405180910390f35b6101f760048036038101906101f29190611e07565b610672565b005b610213600480360381019061020e9190611f1d565b6106d2565b60405161022091906125ac565b60405180910390f35b610243600480360381019061023e9190611e07565b610777565b005b61025f600480360381019061025a9190611fb7565b610797565b60405161026c91906125ac565b60405180910390f35b61028f600480360381019061028a9190611fb7565b610808565b60405161029c9190612308565b60405180910390f35b6102bf60048036038101906102ba9190611d9a565b6108ba565b6040516102cc91906125ac565b60405180910390f35b6102dd610972565b6040516102ea919061238a565b60405180910390f35b61030d60048036038101906103089190611edd565b610a04565b005b61032960048036038101906103249190611e5a565b610a1a565b005b61034560048036038101906103409190611fb7565b610a7c565b604051610352919061238a565b60405180910390f35b610363610b23565b60405161037091906125ac565b60405180910390f35b610393600480360381019061038e9190611dc7565b610b29565b6040516103a0919061236f565b60405180910390f35b60007f780e9d63000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916148061041c575061041b82610bbd565b5b9050919050565b606060008054610432906127d1565b80601f016020809104026020016040519081016040528092919081815260200182805461045e906127d1565b80156104ab5780601f10610480576101008083540402835291602001916104ab565b820191906000526020600020905b81548152906001019060200180831161048e57829003601f168201915b5050505050905090565b60006104c082610c9f565b6104ff576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016104f6906124ec565b60405180910390fd5b6004600083815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff169050919050565b600061054582610808565b90508073ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff1614156105b6576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016105ad9061254c565b60405180910390fd5b8073ffffffffffffffffffffffffffffffffffffffff166105d5610d0b565b73ffffffffffffffffffffffffffffffffffffffff1614806106045750610603816105fe610d0b565b610b29565b5b610643576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161063a9061246c565b60405180910390fd5b61064d8383610d13565b505050565b6106633361065e610665565b610dcc565b565b6000600880549050905090565b61068361067d610d0b565b82610dea565b6106c2576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016106b99061256c565b60405180910390fd5b6106cd838383610ec8565b505050565b60006106dd836108ba565b821061071e576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610715906123ac565b60405180910390fd5b600660008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600083815260200190815260200160002054905092915050565b61079283838360405180602001604052806000815250610a1a565b505050565b60006107a1610665565b82106107e2576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016107d99061258c565b60405180910390fd5b600882815481106107f6576107f561296a565b5b90600052602060002001549050919050565b6000806002600084815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff169050600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff1614156108b1576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016108a8906124ac565b60405180910390fd5b80915050919050565b60008073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff16141561092b576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016109229061248c565b60405180910390fd5b600360008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020549050919050565b606060018054610981906127d1565b80601f01602080910402602001604051908101604052809291908181526020018280546109ad906127d1565b80156109fa5780601f106109cf576101008083540402835291602001916109fa565b820191906000526020600020905b8154815290600101906020018083116109dd57829003601f168201915b5050505050905090565b610a16610a0f610d0b565b8383611124565b5050565b610a2b610a25610d0b565b83610dea565b610a6a576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610a619061256c565b60405180910390fd5b610a7684848484611291565b50505050565b6060610a8782610c9f565b610ac6576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610abd9061252c565b60405180910390fd5b6000610ad06112ed565b90506000815111610af05760405180602001604052806000815250610b1b565b80610afa84611304565b604051602001610b0b9291906122e4565b6040516020818303038152906040525b915050919050565b600a5481565b6000600560008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff16905092915050565b60007f80ac58cd000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff19161480610c8857507f5b5e139f000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916145b80610c985750610c9782611465565b5b9050919050565b60008073ffffffffffffffffffffffffffffffffffffffff166002600084815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1614159050919050565b600033905090565b816004600083815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550808273ffffffffffffffffffffffffffffffffffffffff16610d8683610808565b73ffffffffffffffffffffffffffffffffffffffff167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b92560405160405180910390a45050565b610de68282604051806020016040528060008152506114cf565b5050565b6000610df582610c9f565b610e34576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610e2b9061244c565b60405180910390fd5b6000610e3f83610808565b90508073ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff161480610eae57508373ffffffffffffffffffffffffffffffffffffffff16610e96846104b5565b73ffffffffffffffffffffffffffffffffffffffff16145b80610ebf5750610ebe8185610b29565b5b91505092915050565b8273ffffffffffffffffffffffffffffffffffffffff16610ee882610808565b73ffffffffffffffffffffffffffffffffffffffff1614610f3e576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610f359061250c565b60405180910390fd5b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff161415610fae576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610fa59061240c565b60405180910390fd5b610fb983838361152a565b610fc4600082610d13565b6001600360008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600082825461101491906126e7565b925050819055506001600360008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600082825461106b9190612660565b92505081905550816002600083815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550808273ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef60405160405180910390a4505050565b8173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff161415611193576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161118a9061242c565b60405180910390fd5b80600560008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff0219169083151502179055508173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff167f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c3183604051611284919061236f565b60405180910390a3505050565b61129c848484610ec8565b6112a88484848461163e565b6112e7576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016112de906123cc565b60405180910390fd5b50505050565b606060405180602001604052806000815250905090565b6060600082141561134c576040518060400160405280600181526020017f30000000000000000000000000000000000000000000000000000000000000008152509050611460565b600082905060005b6000821461137e57808061136790612834565b915050600a8261137791906126b6565b9150611354565b60008167ffffffffffffffff81111561139a57611399612999565b5b6040519080825280601f01601f1916602001820160405280156113cc5781602001600182028036833780820191505090505b5090505b60008514611459576001826113e591906126e7565b9150600a856113f4919061287d565b60306114009190612660565b60f81b8183815181106114165761141561296a565b5b60200101907effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916908160001a905350600a8561145291906126b6565b94506113d0565b8093505050505b919050565b60007f01ffc9a7000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916149050919050565b6114d983836117d5565b6114e6600084848461163e565b611525576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161151c906123cc565b60405180910390fd5b505050565b6115358383836119a3565b600073ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff16141561157857611573816119a8565b6115b7565b8173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff16146115b6576115b583826119f1565b5b5b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff1614156115fa576115f581611b5e565b611639565b8273ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff1614611638576116378282611c2f565b5b5b505050565b600061165f8473ffffffffffffffffffffffffffffffffffffffff16611cae565b156117c8578373ffffffffffffffffffffffffffffffffffffffff1663150b7a02611688610d0b565b8786866040518563ffffffff1660e01b81526004016116aa9493929190612323565b602060405180830381600087803b1580156116c457600080fd5b505af19250505080156116f557506040513d601f19601f820116820180604052508101906116f29190611f8a565b60015b611778573d8060008114611725576040519150601f19603f3d011682016040523d82523d6000602084013e61172a565b606091505b50600081511415611770576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611767906123cc565b60405180910390fd5b805181602001fd5b63150b7a0260e01b7bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916817bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916149150506117cd565b600190505b949350505050565b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff161415611845576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161183c906124cc565b60405180910390fd5b61184e81610c9f565b1561188e576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611885906123ec565b60405180910390fd5b61189a6000838361152a565b6001600360008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008282546118ea9190612660565b92505081905550816002600083815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550808273ffffffffffffffffffffffffffffffffffffffff16600073ffffffffffffffffffffffffffffffffffffffff167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef60405160405180910390a45050565b505050565b6008805490506009600083815260200190815260200160002081905550600881908060018154018082558091505060019003906000526020600020016000909190919091505550565b600060016119fe846108ba565b611a0891906126e7565b9050600060076000848152602001908152602001600020549050818114611aed576000600660008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600084815260200190815260200160002054905080600660008773ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600084815260200190815260200160002081905550816007600083815260200190815260200160002081905550505b6007600084815260200190815260200160002060009055600660008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008381526020019081526020016000206000905550505050565b60006001600880549050611b7291906126e7565b9050600060096000848152602001908152602001600020549050600060088381548110611ba257611ba161296a565b5b906000526020600020015490508060088381548110611bc457611bc361296a565b5b906000526020600020018190555081600960008381526020019081526020016000208190555060096000858152602001908152602001600020600090556008805480611c1357611c1261293b565b5b6001900381819060005260206000200160009055905550505050565b6000611c3a836108ba565b905081600660008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600083815260200190815260200160002081905550806007600084815260200190815260200160002081905550505050565b600080823b905060008111915050919050565b6000611cd4611ccf846125ec565b6125c7565b905082815260208101848484011115611cf057611cef6129cd565b5b611cfb84828561278f565b509392505050565b600081359050611d1281612e6b565b92915050565b600081359050611d2781612e82565b92915050565b600081359050611d3c81612e99565b92915050565b600081519050611d5181612e99565b92915050565b600082601f830112611d6c57611d6b6129c8565b5b8135611d7c848260208601611cc1565b91505092915050565b600081359050611d9481612eb0565b92915050565b600060208284031215611db057611daf6129d7565b5b6000611dbe84828501611d03565b91505092915050565b60008060408385031215611dde57611ddd6129d7565b5b6000611dec85828601611d03565b9250506020611dfd85828601611d03565b9150509250929050565b600080600060608486031215611e2057611e1f6129d7565b5b6000611e2e86828701611d03565b9350506020611e3f86828701611d03565b9250506040611e5086828701611d85565b9150509250925092565b60008060008060808587031215611e7457611e736129d7565b5b6000611e8287828801611d03565b9450506020611e9387828801611d03565b9350506040611ea487828801611d85565b925050606085013567ffffffffffffffff811115611ec557611ec46129d2565b5b611ed187828801611d57565b91505092959194509250565b60008060408385031215611ef457611ef36129d7565b5b6000611f0285828601611d03565b9250506020611f1385828601611d18565b9150509250929050565b60008060408385031215611f3457611f336129d7565b5b6000611f4285828601611d03565b9250506020611f5385828601611d85565b9150509250929050565b600060208284031215611f7357611f726129d7565b5b6000611f8184828501611d2d565b91505092915050565b600060208284031215611fa057611f9f6129d7565b5b6000611fae84828501611d42565b91505092915050565b600060208284031215611fcd57611fcc6129d7565b5b6000611fdb84828501611d85565b91505092915050565b611fed8161271b565b82525050565b611ffc8161272d565b82525050565b600061200d8261261d565b6120178185612633565b935061202781856020860161279e565b612030816129dc565b840191505092915050565b600061204682612628565b6120508185612644565b935061206081856020860161279e565b612069816129dc565b840191505092915050565b600061207f82612628565b6120898185612655565b935061209981856020860161279e565b80840191505092915050565b60006120b2602b83612644565b91506120bd826129ed565b604082019050919050565b60006120d5603283612644565b91506120e082612a3c565b604082019050919050565b60006120f8601c83612644565b915061210382612a8b565b602082019050919050565b600061211b602483612644565b915061212682612ab4565b604082019050919050565b600061213e601983612644565b915061214982612b03565b602082019050919050565b6000612161602c83612644565b915061216c82612b2c565b604082019050919050565b6000612184603883612644565b915061218f82612b7b565b604082019050919050565b60006121a7602a83612644565b91506121b282612bca565b604082019050919050565b60006121ca602983612644565b91506121d582612c19565b604082019050919050565b60006121ed602083612644565b91506121f882612c68565b602082019050919050565b6000612210602c83612644565b915061221b82612c91565b604082019050919050565b6000612233602983612644565b915061223e82612ce0565b604082019050919050565b6000612256602f83612644565b915061226182612d2f565b604082019050919050565b6000612279602183612644565b915061228482612d7e565b604082019050919050565b600061229c603183612644565b91506122a782612dcd565b604082019050919050565b60006122bf602c83612644565b91506122ca82612e1c565b604082019050919050565b6122de81612785565b82525050565b60006122f08285612074565b91506122fc8284612074565b91508190509392505050565b600060208201905061231d6000830184611fe4565b92915050565b60006080820190506123386000830187611fe4565b6123456020830186611fe4565b61235260408301856122d5565b81810360608301526123648184612002565b905095945050505050565b60006020820190506123846000830184611ff3565b92915050565b600060208201905081810360008301526123a4818461203b565b905092915050565b600060208201905081810360008301526123c5816120a5565b9050919050565b600060208201905081810360008301526123e5816120c8565b9050919050565b60006020820190508181036000830152612405816120eb565b9050919050565b600060208201905081810360008301526124258161210e565b9050919050565b6000602082019050818103600083015261244581612131565b9050919050565b6000602082019050818103600083015261246581612154565b9050919050565b6000602082019050818103600083015261248581612177565b9050919050565b600060208201905081810360008301526124a58161219a565b9050919050565b600060208201905081810360008301526124c5816121bd565b9050919050565b600060208201905081810360008301526124e5816121e0565b9050919050565b6000602082019050818103600083015261250581612203565b9050919050565b6000602082019050818103600083015261252581612226565b9050919050565b6000602082019050818103600083015261254581612249565b9050919050565b600060208201905081810360008301526125658161226c565b9050919050565b600060208201905081810360008301526125858161228f565b9050919050565b600060208201905081810360008301526125a5816122b2565b9050919050565b60006020820190506125c160008301846122d5565b92915050565b60006125d16125e2565b90506125dd8282612803565b919050565b6000604051905090565b600067ffffffffffffffff82111561260757612606612999565b5b612610826129dc565b9050602081019050919050565b600081519050919050565b600081519050919050565b600082825260208201905092915050565b600082825260208201905092915050565b600081905092915050565b600061266b82612785565b915061267683612785565b9250827fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff038211156126ab576126aa6128ae565b5b828201905092915050565b60006126c182612785565b91506126cc83612785565b9250826126dc576126db6128dd565b5b828204905092915050565b60006126f282612785565b91506126fd83612785565b9250828210156127105761270f6128ae565b5b828203905092915050565b600061272682612765565b9050919050565b60008115159050919050565b60007fffffffff0000000000000000000000000000000000000000000000000000000082169050919050565b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b6000819050919050565b82818337600083830152505050565b60005b838110156127bc5780820151818401526020810190506127a1565b838111156127cb576000848401525b50505050565b600060028204905060018216806127e957607f821691505b602082108114156127fd576127fc61290c565b5b50919050565b61280c826129dc565b810181811067ffffffffffffffff8211171561282b5761282a612999565b5b80604052505050565b600061283f82612785565b91507fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff821415612872576128716128ae565b5b600182019050919050565b600061288882612785565b915061289383612785565b9250826128a3576128a26128dd565b5b828206905092915050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602260045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603160045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b600080fd5b600080fd5b600080fd5b600080fd5b6000601f19601f8301169050919050565b7f455243373231456e756d657261626c653a206f776e657220696e646578206f7560008201527f74206f6620626f756e6473000000000000000000000000000000000000000000602082015250565b7f4552433732313a207472616e7366657220746f206e6f6e20455243373231526560008201527f63656976657220696d706c656d656e7465720000000000000000000000000000602082015250565b7f4552433732313a20746f6b656e20616c7265616479206d696e74656400000000600082015250565b7f4552433732313a207472616e7366657220746f20746865207a65726f2061646460008201527f7265737300000000000000000000000000000000000000000000000000000000602082015250565b7f4552433732313a20617070726f766520746f2063616c6c657200000000000000600082015250565b7f4552433732313a206f70657261746f7220717565727920666f72206e6f6e657860008201527f697374656e7420746f6b656e0000000000000000000000000000000000000000602082015250565b7f4552433732313a20617070726f76652063616c6c6572206973206e6f74206f7760008201527f6e6572206e6f7220617070726f76656420666f7220616c6c0000000000000000602082015250565b7f4552433732313a2062616c616e636520717565727920666f7220746865207a6560008201527f726f206164647265737300000000000000000000000000000000000000000000602082015250565b7f4552433732313a206f776e657220717565727920666f72206e6f6e657869737460008201527f656e7420746f6b656e0000000000000000000000000000000000000000000000602082015250565b7f4552433732313a206d696e7420746f20746865207a65726f2061646472657373600082015250565b7f4552433732313a20617070726f76656420717565727920666f72206e6f6e657860008201527f697374656e7420746f6b656e0000000000000000000000000000000000000000602082015250565b7f4552433732313a207472616e73666572206f6620746f6b656e2074686174206960008201527f73206e6f74206f776e0000000000000000000000000000000000000000000000602082015250565b7f4552433732314d657461646174613a2055524920717565727920666f72206e6f60008201527f6e6578697374656e7420746f6b656e0000000000000000000000000000000000602082015250565b7f4552433732313a20617070726f76616c20746f2063757272656e74206f776e6560008201527f7200000000000000000000000000000000000000000000000000000000000000602082015250565b7f4552433732313a207472616e736665722063616c6c6572206973206e6f74206f60008201527f776e6572206e6f7220617070726f766564000000000000000000000000000000602082015250565b7f455243373231456e756d657261626c653a20676c6f62616c20696e646578206f60008201527f7574206f6620626f756e64730000000000000000000000000000000000000000602082015250565b612e748161271b565b8114612e7f57600080fd5b50565b612e8b8161272d565b8114612e9657600080fd5b50565b612ea281612739565b8114612ead57600080fd5b50565b612eb981612785565b8114612ec457600080fd5b5056fea26469706673582212203ee0d7c0eb41e3162b2a0fc76f0be52c88b7ff53c3abd66453ef54a72f74fdb964736f6c63430008060033";

export class ASMBrain__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    initSupply: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ASMBrain> {
    return super.deploy(initSupply, overrides || {}) as Promise<ASMBrain>;
  }
  getDeployTransaction(
    initSupply: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(initSupply, overrides || {});
  }
  attach(address: string): ASMBrain {
    return super.attach(address) as ASMBrain;
  }
  connect(signer: Signer): ASMBrain__factory {
    return super.connect(signer) as ASMBrain__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ASMBrainInterface {
    return new utils.Interface(_abi) as ASMBrainInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ASMBrain {
    return new Contract(address, _abi, signerOrProvider) as ASMBrain;
  }
}
